module.exports = __webpack_public_path__ + "static/media/upload-company.ee5b9720.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/upload-company.png
// module id = 1050
// module chunks = 0